/* eslint-disable */
const REPORT_RETAIL = {
  REPORT_RETAIL_PROVIDER: 'report/retail/provider',
  REPORT_RETAIL_INVOICE_MASTER: 'report/dispatch/invoice/master',
  REPORT_RETAIL_INVOICE_DETAIL: 'report/dispatch/invoice/detail',
  REPORT_RETAIL_INVOICE_COMPLETE: 'report/dispatch/invoice/complete',
  REPORT_RETAIL_LIST_PROVIDER: 'report/retail/list/provider/new',
  REPORT_RETAIL_LIST_UNIT: 'report/retail/list/unit',
  REPORT_RETAIL_LIST_PRODUCT: 'report/retail/list/product',
  REPORT_RETAIL_PRODUCT: 'report/retail/product',
  REPORT_RETAIL_GET_PRODUCTBYCODE: 'report/retail/get/productByCode',
  REPORT_RETAIL_LIST_GEO: 'report/retail/list/geo',
  REPORT_RETAIL_CUSTOMER_EDITEDADDRESS: 'report/retail/customer/editedAddress',
  REPORT_RETAIL_CUSTOMER_CLUB_ADDRESS: 'report/retail/customer/club/address',

  REPORT_RETAIL_INVOICE_DRIVER: 'report/dispatch/invoice/driver',
  REPORT_RETAIL_CUSTOMER_TRANSACTION_SINGLE: 'report/retail/customer/transaction/single',
  REPORT_RETAIL_CUSTOMER_TRANSACTION_MULTIPLE: 'report/retail/customer/transaction/multiple',
  REPORT_RETAIL_CUSTOMER_RFML: 'report/retail/customer/rfml',
  REPORT_RETAIL_DRIVER_STATEHISTORY: 'report/retail/driver/stateHistory',
  REPORT_RETAIL_PAYMENTFORMALI: 'report/retail/paymentForMali',
  REPORT_RETAIL_PURCHASE_CUSTOMER: 'report/retail/purchase/customer',
  REPORT_RETAIL_PURCHASE_PROVIDER: 'report/retail/purchase/provider',
  REPORT_RETAIL_PURCHASE_FIRSTTIME: 'report/retail/purchase/firstTime',
  REPORT_RETAIL_PURCHASE_MULTIPART: 'report/retail/purchase/multiPack',
  REPORT_RETAIL_PURCHASE_FIRSTDELIVERYPACK: 'report/retail/purchase/firstDeliveryPack',
  REPORT_RETAIL_PURCHASE_BYTIME: 'report/retail/purchase/byTime',
  REPORT_RETAIL_PURCHASE_INVOICEITEM: 'report/retail/purchase/invoiceItem',
  REPORT_RETAIL_PURCHASE_PRODUCT: 'report/retail/purchase/product',
  REPORT_RETAIL_CUSTOMER_CLUB_DETAIL: 'report/retail/customer/club/detail',
  REPORT_RETAIL_SUPPLIED_NOTICE: 'report/retail/supplied/notice',
  REPORT_RETAIL_OIL_MASTER: 'public/retail/report/oil/master',
  REPORT_RETAIL_CUSTOMER_CLUB_PRODUCT: 'report/retail/customer/club/product',

  REPORT_RETAIL_DRIVER_POURCENTAGE: 'public/report/retail/driver/pourcentage'
}
export default REPORT_RETAIL
